import BaseService from "./geral/BaseService";
import { urlApi } from "../config/Constantes";
import { objetoParaQueryString } from "../utils/formatar";

const base = "ProtocoloEletronico";

export default class NotaFiscalFaturamentoService extends BaseService {
    constructor() {
        super(base);
    }

    listarClientes(label = null) {
        const params = label ? `?nome=${label}` : ''
        return super.httpGet(`/${base}/ListarClientes${params}`);
    }

    listarNavios(label = null) {
        const params = label ? `?operacao=${label}` : ''
        return super.httpGet(`/${base}/ListarNavios${params}`);
    }

    listar(filtros) {
        let str = objetoParaQueryString(filtros);
        return super.httpGet(`/${base}/Listar?${str}`);
    }

    listarItens(notaId) {
        return super.httpGet(`/${base}/ListarItens?notaId=${notaId}`);
    }

    listarAnexos(notaId) {
        return super.httpGet(`/${base}/ListarAnexos?notaId=${notaId}`);
    }

    listarDownloadDocumento(ProtEletRelNfRepId) {
        return super.httpGet(`/${base}/DownloadDocumento/${ProtEletRelNfRepId}`);
    }

    downloadAnexo(anexo_id) {
        return super.httpGet(`/${base}/DownloadAnexo/${anexo_id}`)
    }

}


// WEBPACK FOOTER //
// ./src/services/NotaFiscalFaturamentoService.js